import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formContainer", "addButton"]

  showAddForm() {
    this.formContainerTarget.classList.remove("d-none")
    this.addButtonTarget.classList.add("d-none")
  }

  cancelForm() {
    this.formContainerTarget.classList.add("d-none")
    this.addButtonTarget.classList.remove("d-none")
  }
}
